import { useSiteData, usePageContent } from '@/context/SiteDataContext';
import PageHero from '@/components/PageHero';

export default function Media() {
  const { gallery, settings } = useSiteData();
  const c = usePageContent('media');
  const photos = gallery || [];
  const liveUrl = settings?.youtube_live_url || 'https://www.youtube.com/embed/live_stream?channel=UCMlpj4KVaC6QeR8oiT4Sn3g';
  return (
    <div>
      <PageHero slug="media" overline="Watch & Worship" heading="Media Center" />
      <section className="bg-white py-20">
        <div className="max-w-6xl mx-auto px-6">
          <div className="overline mb-3">{c.live_overline || 'Watch Live'}</div>
          <h2 className="font-serif text-3xl text-royal font-bold mb-8 gold-underline">{c.live_heading || 'Live Streaming'}</h2>
          <div className="aspect-video rounded-2xl overflow-hidden shadow-xl">
            <iframe data-testid="youtube-live-embed" width="100%" height="100%" src={liveUrl}
              title="Live" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
          </div>
        </div>
      </section>

      <section className="bg-[#F8F9FA] py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="overline mb-3">{c.gallery_overline || 'Gallery'}</div>
          <h2 className="font-serif text-3xl text-royal font-bold mb-8 gold-underline">{c.gallery_heading || 'Photo Gallery'}</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {photos.map((g) => (
              <div key={g.id} className="aspect-square overflow-hidden rounded-lg group">
                <img src={g.url} alt={g.caption || ''} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
